<template>
  <div class="w-full text-left">
    <div class="text-center mt-6" v-if="studios.length < 1">
      <svg xmlns="http://www.w3.org/2000/svg" class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
</svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900">No studio's</h3>
      <p class="mt-1 text-sm text-gray-500">
        Your account has no connected Studio's
      </p>
      <div class="mt-6">
        <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" v-if="user.type!='admin'">
          Contact Bendico
        </button>
        <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" v-if="user.type=='admin'" @click="goto('/studios/create')">
          Create new
        </button>
      </div>
    </div>


  <div class="relative pb-5 border-b border-gray-200 sm:pb-0 px-5 mt-5" v-if="studios.length > 0">
    <div class="md:flex md:items-center md:justify-between sm:mb-5">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Studios
      </h3>
      <div class="mt-3 flex md:mt-0 md:top-3 md:right-0">
        <button type="button" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="goto('/studios/create')" v-if="user.type=='admin'">
          Create new
        </button>
      </div>
    </div>

  </div>
    <div class="bg-white overflow-hidden shadow sm:rounded-md xl:mt-5">
      <ul class="divide-y divide-gray-200">
        <li
          v-for="(studio) in studios"
          :key="studio._id"
          @click="goto('/studios/' + studio._id)"
        >
          <a class="block hover:bg-gray-50 cursor-pointer">
            <div class="px-4 py-4 flex items-center sm:px-6">
              <div
                class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
              >
                <div class="truncate">
                  <div class="flex text-sm">
                    <p class="font-medium text-indigo-600 truncate">
                      Studio on {{studio.street}}
                    </p>
                    <p class="ml-1 flex-shrink-0 font-normal text-gray-500">
                      in {{studio.city}}
                    </p>
                  </div>
                  <div class="mt-2 flex">
                    <div class="flex items-center text-sm text-gray-500">
                      <!-- Heroicon name: solid/calendar -->
                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p>
                        {{studio.owner[0].firstname}} {{studio.owner[0].lastname}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-5 flex-shrink-0">
                <!-- Heroicon name: solid/chevron-right -->
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
    };
  },
    beforeCreate() {
    this.$store.dispatch("studio/getStudios");
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
    ...mapGetters("studio", {
      studios: "studioList",
    }),
  },
  methods: {
    deleteJob(id) {
      this.$store.dispatch("job/deleteJob", id);
    },
    goto(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="css" scoped>
</style>